/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedItems_viewer = {
    readonly isSeoQuicklookEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_viewer" | "SbSharedThinBrowseItemTrackingProvider_viewer">;
    readonly " $refType": "SbSharedRelatedItems_viewer";
};
export type SbSharedRelatedItems_viewer$data = SbSharedRelatedItems_viewer;
export type SbSharedRelatedItems_viewer$key = {
    readonly " $data"?: SbSharedRelatedItems_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRelatedItems_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedItems_viewer",
  "selections": [
    {
      "alias": "isSeoQuicklookEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SEO_QUICKLOOK"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedThinBrowseItemTrackingProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '9f068f42e44e4a77fa9628a630f68d7d';
export default node;
